import { render } from "./UserMailFilterEditor.vue?vue&type=template&id=0e09d82c"
import script from "./UserMailFilterEditor.vue?vue&type=script&lang=ts"
export * from "./UserMailFilterEditor.vue?vue&type=script&lang=ts"
script.render = render

export default script